var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    { attrs: { elevation: "0", row: "", wrap: "" } },
    [
      _c(
        "v-flex",
        { attrs: { xs12: "", sm6: "", "pa-1": "" } },
        [
          _c("Subheader", { attrs: { title: "Specimena" } }),
          _vm._v(" "),
          _c(
            "v-card",
            { attrs: { elevation: "0" } },
            [
              _c(
                "v-card-text",
                [
                  _c(
                    "v-list",
                    { attrs: { "three-line": "" } },
                    [
                      _vm._l(_vm.plot.Specimena, function (specimen, i) {
                        return [
                          i != 0
                            ? _c("v-divider", { key: `divider-${specimen.Id}` })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("SpecimenHeader", {
                            key: specimen.Id,
                            attrs: { value: specimen },
                          }),
                        ]
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { attrs: { xs12: "", sm6: "", "pa-1": "" } },
        [
          _c("Subheader", { attrs: { title: "Surveys" } }),
          _vm._v(" "),
          _c(
            "v-card",
            { attrs: { elevation: "0" } },
            [
              _c(
                "v-card-text",
                [
                  _c(
                    "v-list",
                    { attrs: { "three-line": "" } },
                    [
                      _vm._l(_vm.plot.Surveys, function (survey, i) {
                        return [
                          i != 0
                            ? _c("v-divider", { key: `divider-${survey.Id}` })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("PlotSurveyHeader", {
                            key: `plot-survey-${survey.ParentSurveyId}-${i}`,
                            attrs: { value: survey },
                          }),
                        ]
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { attrs: { xs12: "", sm6: "", "pa-1": "" } },
        [
          _c("Subheader", { attrs: { title: "Metadata" } }),
          _vm._v(" "),
          _c(
            "v-card",
            { attrs: { elevation: "0" } },
            [
              _c(
                "v-card-text",
                [_c("KVStoreTable", { attrs: { value: _vm.plot.Metadata } })],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(_vm.plot.Surveys, function (survey, i) {
        return [
          _c(
            "v-flex",
            {
              key: `plot-survey-${i}`,
              attrs: { xs12: "", sm6: "", "pa-1": "" },
            },
            [
              _c("Subheader", {
                attrs: { title: `Plot survey ${survey.SurveyDateTimeRaw}` },
              }),
              _vm._v(" "),
              _c(
                "v-card",
                { attrs: { elevation: "0" } },
                [
                  _c(
                    "v-card-text",
                    [_c("KVStoreTable", { attrs: { value: survey.Metadata } })],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }